// extracted by mini-css-extract-plugin
export default {"button":"AltButton_button__u7xbG"};